export const MEMBER_ROUTES = {
  circuits: "circuits",
  protocols: "protocols",
  "workout-plans": "workout-plans",
};
